import type { ServiceDeskAssetsImportType } from '@jira/forge__forge-ui-types/src/common/types/extension.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const serviceDeskAssetsImportTypeForgeDataResource: RouteResource<
	ServiceDeskAssetsImportType[] | null
> = createResource<ServiceDeskAssetsImportType[] | null>({
	type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
	getKey: () => 'extensions',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-assets-import-type-configuration", jiraSpaEntry: "async-resource-servicedesk-assets-import-type-configuration" */ './getData.tsx'
		),
	maxAge: Number.MAX_SAFE_INTEGER,
	isBrowserOnly: true,
});
